import React, { useEffect, useState, useRef } from "react";
import { IoCloseSharp } from "react-icons/io5";
import axios from "../config/axios";
import live_display_socket from "../config/live_display_socket";
import { useTV } from "../hooks/useTV";
import { buttonIds } from "../config/buttonIds";
const orlando_resort_parks = [
  {
    park_name: "Magic Kingdom",
    park_code: "MK",
  },
  {
    park_name: "Hollywood Studios",
    park_code: "HS",
  },
  {
    park_name: "Animal Kingdom",
    park_code: "AK",
  },
  {
    park_name: "EPCOT",
    park_code: "EPCOT",
  },
];

const anaheim_resort_parks = [
  {
    park_name: "Disneyland",
    park_code: "DL",
  },
  {
    park_name: "California Adventure",
    park_code: "CA",
  },
];

const RtvSelector = ({ device, setShowResortSelector }) => {
  const { isTv } = useTV();
  const [focusedButton, setFocusedButton] = useState(null);
  const [parks, setParks] = useState([]);
  const [loading, setLoading] = useState(true);
  const anaheimButtonRef = useRef(null);
  const orlandoButtonRef = useRef(null);
  const exitButtonRef = useRef(null);

  useEffect(() => {
    axios
      .get(`/parks/public/${device._id}`, { withCredentials: true })
      .then((response) => {
        setParks(response.data.parks);
        setLoading(false);
      })
      .catch((error) => {
        // console.log(error)
      });
  }, []);

  // Auto-focus first available button when component mounts in TV mode
  useEffect(() => {
    if (isTv && !loading) {
      if (showAnaheimResortButton() && anaheimButtonRef.current) {
        setFocusedButton("anaheim");
        anaheimButtonRef.current.focus();
      } else if (showOrlandoResortButton() && orlandoButtonRef.current) {
        setFocusedButton("orlando");
        orlandoButtonRef.current.focus();
      }
    }
  }, [isTv, loading, parks]);

  useEffect(() => {
    if (parks.length > 0) {
      if (getListOfResorts().length === 1) {
        setShowResortSelector(false);
        updateDeviceView("RTV__" + getListOfResorts()[0]);
      }
    }
  }, [parks]);

  const getListOfResorts = () => {
    const resorts = [];
    if (showAnaheimResortButton()) {
      resorts.push("Anaheim");
    }
    if (showOrlandoResortButton()) {
      resorts.push("Orlando");
    }
    return resorts;
  };

  const showAnaheimResortButton = () => {
    // if parks contains any of the anaheim_resort_parks return true. else false
    return parks.some((park) =>
      anaheim_resort_parks.some(
        (anaheim_park) => anaheim_park.park_code === park.park_code
      )
    );
  };

  const showOrlandoResortButton = () => {
    // if parks contains any of the orlando_resort_parks return true. else false
    return parks.some((park) =>
      orlando_resort_parks.some(
        (orlando_park) => orlando_park.park_code === park.park_code
      )
    );
  };

  const updateDeviceView = (view) => {
    axios
      .patch(
        `/users/device/${device._id}`,
        { screen_view: view },
        { withCredentials: true }
      )
      .then(() => {
        live_display_socket.emit("remote_refresh", {
          device_id: device?._id,
        });
      })
      .catch((error) => {});
  };

  // Button style with focus handling
  const getButtonStyle = (buttonId, baseStyle) => {
    const focusedStyle =
      isTv && focusedButton === buttonId
        ? {
            border: "6px solid #3ADF3C",
            outline: "none",
          }
        : {};

    return {
      ...baseStyle,
      ...focusedStyle,
    };
  };

  // Base button style
  const baseButtonStyle = {
    marginLeft: "10px",
    border: isTv ? "6px solid blue" : "2px solid blue",
    background: "transparent",
    color: "blue",
    fontFamily: "Lato",
    fontSize: isTv ? "60px" : "40px",
    padding: isTv ? "10px 25px" : "0px 20px",
    borderRadius: "20px",
    fontWeight: "700",
    margin: "10px 0px",
    cursor: "pointer",
  };

  // Exit button style
  const exitButtonStyle = {
    ...baseButtonStyle,
    border: isTv ? "6px solid red" : "2px solid red",
    color: "red",
    marginTop: "20px",
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        position: "absolute",
        top: "0%",
        backgroundColor: "white",
        width: "100vw",
        height: "100vh",
        zIndex: 50,
        opacity: "80%",
      }}
    >
      {!isTv && (
        <button
          tabIndex={0}
          onFocus={() => setFocusedButton("close")}
          onBlur={() => setFocusedButton(null)}
          onClick={() => {
            setShowResortSelector(false);
            document.getElementById(buttonIds.bottomBar.resort).focus();
          }}
          style={{
            position: "absolute",
            top: "5%",
            right: "3%",
            background: "transparent",
            border:
              isTv && focusedButton === "close" ? "6px solid #3ADF3C" : "none",
            borderRadius: "50%",
            padding: "5px",
            cursor: "pointer",
            outline: "none",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <IoCloseSharp size={isTv ? 100 : 60} />
        </button>
      )}

      <div>
        {showAnaheimResortButton() && (
          <button
            ref={anaheimButtonRef}
            tabIndex={0}
            onFocus={() => setFocusedButton("anaheim")}
            onBlur={() => setFocusedButton(null)}
            onClick={() => {
              updateDeviceView("RTV__Anaheim");
              setShowResortSelector(false);
            }}
            style={getButtonStyle("anaheim", baseButtonStyle)}
          >
            Anaheim Resort
          </button>
        )}
      </div>
      <div>
        {showOrlandoResortButton() && (
          <button
            ref={orlandoButtonRef}
            tabIndex={0}
            onFocus={() => setFocusedButton("orlando")}
            onBlur={() => setFocusedButton(null)}
            onClick={() => {
              updateDeviceView("RTV__Orlando");
              setShowResortSelector(false);
            }}
            style={getButtonStyle("orlando", baseButtonStyle)}
          >
            Orlando Resort
          </button>
        )}

        {loading && (
          <button
            style={{
              marginLeft: "10px",
              border: "none",
              background: "transparent",
              color: "blue",
              fontFamily: "Lato",
              fontSize: "40px",
              padding: "0px 20px",
              borderRadius: "20px",
              fontWeight: "700",
              margin: "10px 0px",
              cursor: "pointer",
            }}
          >
            Loading...
          </button>
        )}
      </div>

      {isTv && !loading && (
        <div style={{ marginTop: "20px" }}>
          <button
            ref={exitButtonRef}
            tabIndex={0}
            onFocus={() => setFocusedButton("exit")}
            onBlur={() => setFocusedButton(null)}
            onClick={() => {
              document.getElementById(buttonIds.bottomBar.resort).focus();
              setShowResortSelector(false);
            }}
            style={getButtonStyle("exit", exitButtonStyle)}
          >
            Exit
          </button>
        </div>
      )}
    </div>
  );
};

export default RtvSelector;
